import { useEffect, useState } from "react";
import { watchLoading, type LoadingStage } from "./loadingState";
import "../../styles/scene-recovery.css";

const messages = {
  sky: { waiting: "夜空正在铺开。", slow: "夜空加载得有些慢，可以再试一次，或先往前走。", error: "夜空暂时没能载入。可以重试，或带着这份祝福继续。" },
  opening: { waiting: "星光正在聚拢。", slow: "开场还在准备。可以重新载入夜空，或先去摘星。", error: "开场暂时没能展开。可以再试一次，或先去摘星。" },
  story: { waiting: "星星和花，正在等你。", slow: "这一幕加载得有些慢。可以再试一次，也可以先看生日落款。", error: "这一幕暂时没能载入。可以重试，也可以先看生日落款。" },
  celebration: { waiting: "愿望已收好，烟花正在准备。", slow: "烟花准备得有些慢。可以再试一次，或先看祝福。", error: "烟花暂时没能载入。可以重试，也可以先看生日落款。" },
};

interface NoticeProps {
  scene: keyof typeof messages;
  failed?: boolean;
  onRetry: () => void;
  onContinue: () => void;
  continueLabel: string;
  inline?: boolean;
}

export function LoadingNoticeView({ scene, stage, onRetry, onContinue, continueLabel, inline }: Omit<NoticeProps, "failed"> & { stage: LoadingStage | "error" }) {
  if (stage === "hidden") return null;
  const canRecover = stage === "slow" || stage === "error";
  return <div className={`scene-recovery${inline ? " scene-recovery--inline" : ""}`}>
    <p role="status" aria-live="polite">{messages[scene][stage]}</p>
    {canRecover && <div className="scene-recovery__actions">
      <button type="button" onClick={onRetry}>重新载入</button>
      <button type="button" onClick={onContinue}>{continueLabel}</button>
    </div>}
  </div>;
}

export function LoadingNotice({ failed = false, ...props }: NoticeProps) {
  const [stage, setStage] = useState<LoadingStage>("hidden");
  useEffect(() => {
    if (failed) return;
    return watchLoading(setStage);
  }, [failed]);
  return <LoadingNoticeView {...props} stage={failed ? "error" : stage} />;
}
